<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-2">
              404
            </h1>
            <h4 class="pt-1">
              {{ $t('Oops! You\'re lost.') }}
            </h4>
            <p class="text-muted">
              {{ $t('The page you are looking for was not found.') }}
            </p>
            <p>
              <router-link :to="{name: 'Dashboard'}">
                {{ $t('Go to dashboard') }}
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPage404',
};
</script>
